








import Vue from "vue"
import axios from "axios"
import Component from "vue-class-component"
import EventBus from "./eventBus"
import "../node_modules/nprogress/nprogress.css"
import firebase from "firebase/app"
import "firebase/auth"

@Component({
  name: "App",
})
export default class extends Vue {
  created() {
    var self = this
    window.addEventListener("resize", this.handleResize)
    this.handleResize()

    axios.interceptors.response.use(undefined, function(err) {
      return new Promise(function(resolve, reject) {
        if (
          err.request.status === 401 &&
          err.config &&
          !err.config.__isRetryRequest
        ) {
          firebase.auth().signOut()
        }
        throw err
      })
    })
  }

  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  }

  handleResize() {
    EventBus.$emit("WINDOW_RESIZED", {})
  }
}
